<template>
  <div>
    <div class="product-card product-card--2">
      <div class="product-card__box">
        <div class="product-card__media"> <img class="product-card__img" :src="picture" alt="" />

        </div>
        <div class="product-card__info">
          <span class="product-prev-price" v-if="product.has_percentage_discount">{{ product.discount_percent }}</span>
          <div class="product-card__title"> <a :href="productUrl">{{ product.name }}</a></div>

          <div class="uk-grid uk-grid-collapse">
              <div class="uk-width-1-2 uk-grid-margin uk-first-column" >
                <div class="product-card__price" v-html="product.formatted_price"></div>
                <div class="product-card__price_wvat"> {{product.price_without_tax.formatted}} bez DPH</div>
              </div>
            <div class="uk-width-1-2 uk-grid-margin product-card__inventory">
              na sklade ihneď k odberu {{ product.qty }} ks
          </div>
          </div>






          <div class="cart-button">

            <button class="uk-button uk-button-danger uk-button-small add-to-cart"
                    :class="{ 'btn-loading': cartAddLoading }"
                    tabindex="0"
                    @click="addToBasket"
                    :disabled="product.is_out_of_stock"
                    v-if="noOptions || product.is_out_of_stock">Detail produktu
            </button>
            <a :href="productUrl"  v-else>
            <button class="uk-button uk-button-danger uk-button-small add-to-cart"
                    :class="{ 'btn-loading': cartAddLoading }">Detail produktu</button>
            </a>


            <span class="sold-out-tag position-top-right" v-if="!product.in_stock">{{ $trans('outOfStock') }}</span>
          </div>


        </div>
      </div>


    </div>
  </div>
</template>

<script>
import ProductRating from './ProductRating.vue';
import ProductCardMixin from '../mixins/ProductCardMixin';

export default {

  components: {ProductRating},

  computed: {

    locale() {
      return window.App.locale;
    }

  },

  mixins: [
    ProductCardMixin,
  ],

  props: ['product', 'classname'],
};
</script>

<style>
.float-left {
  float: left;
}

.la-heart {
  color: #9e9e9e;
}

.la-heart.las {
  color: red;
}

.product-card {
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  transition: box-shadow .2s;
  cursor: pointer;
}

.product-card__price {
  color: #000;
  font-size: 22px;
  font-weight: bold;
  text-align: left;
  line-height: 1.1;

}
.product-card__price_wvat {
  color: #9b9b9b;
  font-size: 12px;
  line-height: 1.1875rem;
  text-align: left;

}
.product-card__title a{
  color: #000;
  font-size: 14px !important;
  text-decoration: underline;
  text-align: left;
  line-height: 1rem;
}


.uk-button.add-to-cart {
  text-align: center;
  width: 100%;
  float: right;
  height: 38px;
}
.uk-button.add-to-cart span {
  text-align: center;
  font-size: 14px;
}

.product-card__info {
  background: #fff !important;
}


.cart-button {
  margin-top: 20px;
  margin-right: 0;
}



</style>
